// This file is generated by next-core EcmascriptClientReferenceModule.
import { registerClientReference } from "react-server-dom-turbopack/server";
export const VanMenhForm = registerClientReference(
    function() { throw new Error("Attempted to call VanMenhForm() from the server but VanMenhForm is on the client. It's not possible to invoke a client function from the server, it can only be rendered as a Component or passed to props of a Client Component."); },
    "[project]/components/ai/van-menh-form.tsx",
    "VanMenhForm",
);
